module.exports = __webpack_public_path__ + "static/media/kkd-multi-scene.bce046c9.png";